<div data-cy="individual-context-detail__page" style="height:100%;">
    <!-- <div class="flex align-center px-20 py-20 gap-15 panel-header">
        <span class="iq-badge">
            <img src="../../../../../../assets/png/iq_analysis_white.png" alt="IQ">
        </span>
        <span class="generic-clr">
            {{ 'contexts.label' | transloco }}
        </span>
    </div> -->

    <div class="panel-body ts-14 pb-10">
        <div class="px-15 mb-10">
            <!-- <div class="go-back ts-14 d-cursor-hand" (click)="goBack()">
                <mat-icon>keyboard_backspace</mat-icon>
                <span>{{ 'contexts.back_to_overview' | transloco }}</span>
            </div> -->
            
            <!-- Global loading indicator at the top while fetching existing context details -->
            <div *ngIf="isLoadingExistingContext()" class="loading-context-container mt-20">
                <mat-progress-bar mode="indeterminate" class="context-loading-bar"></mat-progress-bar>
                <p class="loading-text mt-10">{{ 'contexts.loading_context_details' | transloco }}</p>
            </div>
        </div>

        <!-- Content hidden while loading existing context details -->
        <ng-container *ngIf="!isLoadingExistingContext()">
            <div class="px-15 mb-10">
                <h3 class="mt-20 mb-0 ctx-type" *ngIf="contextItemDetail?.type!=='Physical'">{{ 'contexts.context_type.' + contextItemDetail?.type?.toLowerCase() | transloco }}</h3>

                <ng-container *ngIf="contextItemDetail?.type!=='Physical' && contextItemDetail?.type!=='Stakeholder' && !contextItemDetail?.item?.isManual">
                    <h2 class="mb-0">{{contextItemDetail?.item?.context_subtype}}</h2>
                    <p class="mb-0">{{contextItemDetail?.item?.context_subtype_summary}}</p>
                    <span>{{ contextItemDetail?.item?.context_items?.length || 0 }} {{ getSubthemeContextLabel( contextItemDetail?.type, contextItemDetail?.item?.context_items?.length || 0) | transloco }}</span>
                </ng-container>

                <ng-container *ngIf="contextItemDetail?.type=='Stakeholder'">
                    <h2 class="mb-0">{{contextItemDetail?.item?.name}}</h2>
                    <p>1 {{ 'contexts.context_object_linked' | transloco }}</p>
                </ng-container>

                <ng-container *ngIf="contextItemDetail?.type=='Physical' && contextItemDetail?.type!='Stakeholder'">
                    <h2 class="mb-0 mt-10">{{contextItemDetail?.item?.text}}</h2>
                    <p>{{contextItemDetail?.item?.stakeholders?.length ?? 0}} {{ 'contexts.stakeholder_linked' | transloco }}</p>
                </ng-container>

                <!-- <div class="detail-table-card1 col-xs-12 mb-10 mt-20 mt px-0" *ngIf="contextItemDetail?.item?.isManual || contextItemDetail?.type=='Physical' || contextItemDetail?.type=='Stakeholder'" (mouseleave)="contextItemDetail?.type=='Stakeholder' && onLeaveContextItem()" (mouseenter)="contextItemDetail?.type=='Stakeholder' && onHoverContextItem(contextItemDetail.type, contextItemDetail?.item)"> -->
                <div class="detail-table-card1 col-xs-12 mb-10 mt-20 mt px-0" *ngIf="contextItemDetail?.item?.isManual || contextItemDetail?.type=='Physical' || contextItemDetail?.type=='Stakeholder'">
                    <div class="flex justify-btw align-center px-15 py-15 card1-title" [style.border-radius]="'16px 16px 0 0'">
                        <h3 class="generic-clr ts-13 mb-0 mt-0" [matTooltip]="contextItemDetail?.item?.name || contextItemDetail?.item?.text">{{contextItemDetail?.item?.name || contextItemDetail?.item?.text}}</h3>

                        <div class="flex align-center">
                            <ng-container 
                            *ngTemplateOutlet="addRemoveProjectUI; 
                            context: { $implicit: { item: contextItemDetail.item } }"
                            ></ng-container>
                            <!-- <span class="accordin-arrow mr-8 d-cursor-hand">
                                <i class="uil uil-angle-up" *ngIf="false"></i>
                                <i class="uil uil-angle-down"></i>
                            </span> -->
                        </div>
                    </div>

                    <ng-container 
                        *ngTemplateOutlet="itemsConnectionPanel; 
                        context: { $implicit: { item: contextItemDetail.item } }"
                    ></ng-container>
                    <!-- for context  -->
                    <p *ngIf="contextItemDetail.type == 'Physical'" class="px-15 pt-15 ts-14">{{contextItemDetail?.item?.text}}</p>
                    <div *ngIf="contextItemDetail?.type=='Physical'" class="card1-body px-15 py-15">
                        <div class="card1-table">
                            <div class="table-cell flex align-center gap-10 py-8 px-8" *ngFor="let tag of contextItemDetail?.item?.metadata?.tags | keyvalue; let i = index" [ngStyle]="{'background-color': item % 2 === 0 ? '#ffffff' : '#f2f3f8'}">
                                <span class="col-xs-6">{{getTagLabel(tag.key) | capitaliz | trunc:25}}</span>
                                <span class="col-xs-6">{{tag.value | capitaliz | trunc:30}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- for stakeholder  -->
                    <p *ngIf="contextItemDetail.type == 'Stakeholder'" class="px-15 pt-15 ts-14">{{contextItemDetail?.item?.name}}</p>
                    <div *ngIf="contextItemDetail?.type=='Stakeholder'" class="card1-body px-15 py-15">
                        <div class="card1-table">
                            <div class="table-cell flex align-center gap-10 py-8 px-8" *ngFor="let key of stkkeys; let i = index" [ngStyle]="{'background-color': i % 2 === 0 ? '#ffffff' : '#f2f3f8'}">
                                <span class="col-xs-6">{{ getTagLabel(key) | capitaliz | trunc:25 }}</span>
                                <span class="col-xs-6">{{ stkvalues[i] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of contextItemDetail?.item?.context_items" (mouseleave)="onLeaveContextItem()" (mouseenter)="onHoverContextItem(contextItemDetail.type, item)"> -->
            <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of contextItemDetail?.item?.context_items">
                <div class="flex justify-btw align-center px-15 py-15 card1-title" [ngStyle]="{'border-radius': isItemExpanded(item) ? '16px 16px 0 0':'16px 16px 16px 16px'}">
                    <h5 class="generic-clr ts-13 mb-0 mt-0" [matTooltip]="item.text" (click)="toggleItemExpansion(item, contextItemDetail.type)">{{item.text | trunc:20}}</h5>

                    <div class="flex align-center">
                        <ng-container 
                        *ngTemplateOutlet="addRemoveProjectUI; 
                        context: { $implicit: { item } }"
                        ></ng-container>
                        <span data-cy="individual-context-detail__toggle-item-expansion" class="accordin-arrow mr-8 d-cursor-hand" (click)="toggleItemExpansion(item, contextItemDetail.type)">
                            <i class="uil uil-angle-up" *ngIf="isItemExpanded(item)"></i>
                            <i class="uil uil-angle-down" *ngIf="!isItemExpanded(item)"></i>
                        </span>
                    </div>
                </div>

                <ng-container *ngIf="isItemExpanded(item)">
                    <ng-container 
                        *ngTemplateOutlet="itemsConnectionPanel; 
                        context: { $implicit: { item } }"
                    ></ng-container>

                    <p class="px-15 pt-15 ts-14" *ngIf="contextItemDetail?.type=='Physical'">{{item?.description}}</p>

                    <ng-container *ngIf="contextItemDetail?.type=='Social'">
                        <div>
                            <app-context-metrices-bar-chart [chartData]="item"></app-context-metrices-bar-chart>
                        </div>
                        
                        <div class="pb-4 mx-15 my-15 resident-value" *ngIf="item?.parameters?.[0]?.source_data?.a_inw">
                            <h3 class="px-15 py-6">{{ 'contexts.number_of_residents' | transloco }}</h3>
                            <h2 class="generic-blue px-15">{{item?.parameters?.[0]?.source_data.a_inw ?? '0.00'}}</h2>
                        </div>
                    </ng-container>

                    <div class="px-15" *ngIf="contextItemDetail?.type=='Political'">
                        <h3 class="mt-20 mb-0 generic-blue">{{ 'contexts.context_type.' + contextItemDetail?.type?.toLowerCase() | transloco }}</h3>
                        <h2>{{item?.parameters?.[0]?.parameter_label}}</h2>
                        <p>{{item?.description}}</p>
                        <p>{{item?.parameters?.[0]?.bucket_label}}</p>
                        <p *ngIf="item?.parameters?.[0]?.value > 0">{{ 'contexts.value' | transloco }} {{item?.parameters?.[0]?.value}}</p>
                        <p>{{item?.parameters?.[0]?.source_data?.document_count}}</p>
                        <div class="mt-6" *ngFor="let prop of item?.parameters?.[0]?.source_data?.themes">
                            <h3 class="theme-name">{{prop?.name}}</h3>
                            <p>{{prop?.summary}}</p>
                            <hr class="hr-line">
                        </div>
                        <div *ngIf="item?.parameters?.[0]?.source_data">
                            <div *ngFor="let role of item?.parameters?.[0]?.source_data | keyvalue">
                                <ng-container *ngIf="isArrayOfStrings(role.value) && role.key !== 'themes' && role.key !== 'document_count'">
                                    <h3 class="role heading">{{ role.key }}</h3>
                                    <div class="card1-body px-15 py-15">
                                        <div class="card1-table">
                                            <div *ngFor="let entry of role.value; let i = index" class="table-cell flex align-center gap-10 py-8 px-8" [ngStyle]="{ 'background-color': i % 2 === 0 ? '#ffffff' : '#f2f3f8' }">
                                                <span class="col-xs-6">{{ entry.includes('(') ? entry.split('(')[0].trim() : entry }}</span>
                                                <span class="col-xs-6" [ngStyle]="{ 'font-style': !entry.includes('(') ? 'italic' : 'normal', 'color': !entry.includes('(') ? '#999' : 'inherit' }">{{ entry.includes('(') ? entry.substring(entry.indexOf('(') + 1, entry.lastIndexOf(')')) : '' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    
                    <div class="px-15" *ngIf="contextItemDetail?.type=='Emotional'">
                        <p class="summary-content">{{item?.parameters?.[0]?.source_data?.summary}}</p>
                        <div class="info-card">
                            <ng-container>
                                <h2>{{item?.parameters?.[0]?.parameter_label}}</h2>
                                <p> {{ 'contexts.old_town_district_municipality' | transloco }} {{item?.municipality_name}} </p>
                                <div *ngFor="let prop of item?.parameters?.[0]?.source_data?.themes">
                                    <ng-container *ngIf="prop?.keywords">
                                        <h2>Thema</h2>
                                        <p>Trefwoorden: {{prop?.keywords?.join(', ')}}</p>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <div *ngFor="let theme of item?.parameters?.[0]?.source_data?.themes; let i = index">
                                <h3 class="theme-name mt-20">{{theme?.name}}</h3>
                                <p class="theme-summary">{{theme?.summary}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="px-15" *ngIf="contextItemDetail?.type=='Regulatory'">
                        <h2 *ngIf="item?.text">{{item?.text}}</h2>
                        <p *ngIf="item?.description" class="mb-10">{{item?.description}}</p>
                        <!-- Regelgeving en procedures -->
                        <h2 *ngIf="item?.parameters?.[0]?.parameter_label">{{item?.parameters?.[0]?.parameter_label}}</h2>
                        <p *ngIf="item?.parameters?.[0]?.source_data?.plan_type"><strong>{{ 'contexts.plan_type' | transloco }}:</strong> {{item?.parameters?.[0]?.source_data?.plan_type}}</p>
                        <p *ngIf="item?.parameters?.[0]?.source_data?.regel_status"><strong>{{ 'contexts.regel_status' | transloco }}:</strong> {{item?.parameters?.[0]?.source_data?.regel_status}}</p>
                        <p *ngIf="item?.parameters?.[0]?.source_data?.external_id"><strong>{{ 'contexts.external_id' | transloco }}:</strong> {{item?.parameters?.[0]?.source_data?.external_id}}</p>
                        <p *ngIf="item?.parameters?.[0]?.source_data?.plan_identificatie"><strong>{{ 'contexts.plan_identificatie' | transloco }}:</strong> {{item?.parameters?.[0]?.source_data?.plan_identificatie}}</p>
                        <p *ngIf="item?.parameters?.[0]?.source_data?.publicerendBevoegdGezag?.naam"><strong>{{ 'contexts.publicerend_bevoegd_gezag' | transloco }}:</strong> {{item?.parameters?.[0]?.source_data?.publicerendBevoegdGezag?.naam}}</p>
                        <!-- Procedure -->
                        <h2 *ngIf="item?.parameters?.[0]?.source_data?.procedures">{{ 'contexts.procedures' | transloco }}</h2>
                        <div *ngFor="let prop of item?.parameters?.[0]?.source_data?.procedures">
                            <h2>{{prop?.name}}</h2>
                            <p>{{prop?.status}}</p>
                            <p>{{prop?.implications}}</p>
                        </div>
                        <!-- Project Relevance -->
                        <h2 *ngIf="item?.parameters?.[0]?.source_data?.project_relevance">{{ 'contexts.project_relevance' | transloco }}</h2>
                        <!-- ?<p class="generic-blue">{{item?.parameters?.[0]?.source_data?.project_relevance?.mentioned ? ('contexts.project_not_mentioned' | transloco):( 'contexts.project_is_mentioned' | transloco )}}</p> -->
                        <p>{{item?.parameters?.[0]?.source_data?.project_relevance?.details}}</p>
                        <div class="documents">
                            <h2 style="text-align: left; margin-bottom: 10px;" *ngIf="item?.parameters?.[0]?.source_data?.documents?.length">{{ 'contexts.documents' | transloco }}</h2>
                            <div *ngFor="let doc of item?.parameters?.[0]?.source_data?.documents" style="margin-bottom: 5px;">
                                <ng-container *ngIf="doc.url || doc.href">
                                    <a data-cy="individual-context-detail__link" [href]="doc.url || doc.href" target="_blank">
                                        {{ (doc.url || doc.href) | slice:0:30 }}{{ (doc.url || doc.href)?.length > 30 ? '...' : '' }}
                                    </a>
                                    <span class="doc-title" *ngIf="doc.title">({{ doc.title }})</span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #addRemoveProjectUI let-data>
    <div class="flex align-center">
        <button data-cy="individual-context-detail__add-to-project-btn" *ngIf="!addedMap[getItemUuid(data.item)]" mat-flat-button (click)="addToProject(data, 'add')" [disabled]="(isProcessing() && processingItemId() === getItemUuid(data.item)) || isSharedSubproject()"> 
            <i class="d-text-middle uil uil-plus-circle unicon-icon"></i>
            <span style="color: white !important">{{ 'contexts.add_to_project' | transloco }}</span>
        </button>
        <button data-cy="individual-context-detail__remove-btn" *ngIf="addedMap[getItemUuid(data.item)]" mat-button class="remove-btn" (click)="addToProject(data.item, 'remove')" [disabled]="isProcessing() && processingItemId() === getItemUuid(data.item)">
            <i class="d-text-middle uil uil-trash unicon-icon"></i>
            <span style="color: white !important">{{ 'contexts.remove_from_project' | transloco }}</span>
        </button>
        <mat-spinner [diameter]="20" *ngIf="isProcessing() && processingItemId() === getItemUuid(data.item)"></mat-spinner>
    </div>
</ng-template>

<ng-template #itemsConnectionPanel let-data>
    <mat-accordion *ngIf="addedMap[getItemUuid(data.item)]">
        <mat-expansion-panel class="add-connect-generic-accordin" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <strong>{{ 'contexts.connected_items' | transloco }}</strong>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex items-end gap-20">
                <div class="mt-10 item" *ngIf="contextItemDetail?.type !== 'Stakeholder'">
                    <mat-progress-bar *ngIf="!loaded" mode="buffer"></mat-progress-bar>
                    <app-add-connect-generic data-cy="individual-context-detail__add-connect-generic" 
                        *ngIf="loaded && addedMap[getItemUuid(data.item)]" 
                        parentType="contexts" 
                        [isReadOnly]="false" 
                        (onChange)="updateEntitiesFromGeneric($event, data.item)" 
                        [parent]="data.item" 
                        [data]="entities" 
                        [types]="['stakeholders','issues']">
                    </app-add-connect-generic>
                </div>
                <div class="mt-10 item" *ngIf="contextItemDetail?.type === 'Stakeholder'">
                    <app-generic-multiselect-checkbox data-cy="individual-context-detail__generic-multiselect-checkbox" [placeholder]="'contexts.labels' | transloco" name="contexts" ngDefaultControl [(ngModel)]="selectedContextsMap[getItemUuid(data.item)]" (ngModelChange)="updateStakeholderConnections(data.item, $event, 'contexts')" [required]="false" [maxChipMessage]="'+ {count} '+('reusable.more' | transloco)+' users ...'" [uniqueId]="'responsible-users'">
                        <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' | transloco}}</app-generic-multiselect-checkbox-option-all>
                        <app-generic-multiselect-checkbox-option *ngFor="let context of contexts" [value]="context">
                            {{ context.text }}
                        </app-generic-multiselect-checkbox-option>
                    </app-generic-multiselect-checkbox>
                </div>

            </div>
        </mat-expansion-panel>
    </mat-accordion>
</ng-template>
